import { render, staticRenderFns } from "./Proyectos.vue?vue&type=template&id=002c9f46&scoped=true"
import script from "./Proyectos.vue?vue&type=script&lang=js"
export * from "./Proyectos.vue?vue&type=script&lang=js"
import style0 from "./Proyectos.vue?vue&type=style&index=0&id=002c9f46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002c9f46",
  null
  
)

export default component.exports